import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowDownIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M6 8L9.29289 11.2929C9.62623 11.6262 9.79289 11.7929 10 11.7929C10.2071 11.7929 10.3738 11.6262 10.7071 11.2929L14 8'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowDownIcon;
